import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';

class AuthService {
  isAuthenticated(): boolean {
    const sessionToken = Cookies.get(CONFIG.AUTH.SSID);
    return !!sessionToken;
  }

  sendToLoginPage(): void {
    const redirect = encodeURIComponent(globalThis.location.href);
    const loginUrl = CONFIG.getLoginServiceUrl();
    const url = `${loginUrl}?np_red=${redirect}`;
    globalThis.location.href = url;
  }

  logout(): void {
    const logoutUrl = CONFIG.getLoginServiceUrl();
    
    const redirectUrl = encodeURIComponent(globalThis.location.origin);
    const url = `${logoutUrl}logout?np_red=${redirectUrl}`;
    
    this.clearLocalCookies();
    globalThis.location.href = url;
  }

  private clearLocalCookies(): void {
    const cookieOptions = {
      domain: CONFIG.getCookieDomain(),
      path: '/'
    };

    Cookies.remove(CONFIG.AUTH.SSID, cookieOptions);
    Cookies.remove(CONFIG.AUTH.USER_ID, cookieOptions);
    Cookies.remove(CONFIG.AUTH.SSID);
    Cookies.remove(CONFIG.AUTH.USER_ID);
  }

  logoutLocal(): void {
    this.clearLocalCookies();
  }
}

const authService = new AuthService();
export default authService;